module.exports = __webpack_public_path__ + "static/media/busd.17a330b3.png";